import { render, staticRenderFns } from "./Diminution.vue?vue&type=template&id=7a2c7af8"
import script from "./Diminution.vue?vue&type=script&lang=js"
export * from "./Diminution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports